<script>
import { defineComponent as _defineComponent } from "vue";
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "magic-player-display-time" };
import { computed, inject } from "vue";
import { usePlayerMediaApi } from "../composables/private/usePlayerMediaApi";
import { formatTime } from "@maas/vue-equipment/utils";
import { MagicPlayerInstanceId } from "../symbols";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicPlayerDisplayTime",
  props: {
    type: { type: String, required: false, default: "current" }
  },
  setup(__props) {
    const instanceId = inject(MagicPlayerInstanceId);
    if (!instanceId) {
      throw new Error(
        "MagicPlayerDisplayTime must be nested inside MagicPlayerVideoControls or MagicPlayerAudioControls."
      );
    }
    const { currentTime, remainingTime, duration } = usePlayerMediaApi({
      id: instanceId
    });
    const stringifiedTime = computed(() => {
      switch (__props.type) {
        case "current":
          return formatTime(currentTime.value, currentTime.value);
        case "remaining":
          return `-${formatTime(remainingTime.value, remainingTime.value)}`;
        case "duration":
          return formatTime(duration.value, duration.value);
        default:
          return "";
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(
        "div",
        _hoisted_1,
        _toDisplayString(stringifiedTime.value),
        1
        /* TEXT */
      );
    };
  }
});
</script>
